/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WeatherMoonIcon16Regular = forwardRef('WeatherMoonIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.805 1.7c.222.279.302.687.128 1.065a4.75 4.75 0 0 0 6.302 6.302 1.02 1.02 0 0 1 1.064.128c.29.23.472.648.319 1.091a7 7 0 1 1-8.904-8.904.98.98 0 0 1 1.091.319ZM5.174 3.28a5.5 5.5 0 1 0 7.546 7.546A6.25 6.25 0 0 1 5.174 3.28Z" })));
});
